import Sidebar from "../components/Sidebar";
import { useStaffMembers } from '../middleware/guild';
import { SkeletonStaffCard, staggerStyle } from "../components/Skeleton";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import "../styles/Staff.css";

/** Discord colour ints arrive as decimals; 0 means "no colour set". */
const roleColor = (color) =>
  color ? `#${color.toString(16).padStart(6, "0")}` : "var(--isn-text)";


const Staff = () => {
  const { members, getHighestRole, allowedRoles, loading } = useStaffMembers();

  const capitalizeName = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // Group members by their highest role
  const grouped = {};
  allowedRoles.forEach(role => { grouped[role] = []; });
  members.forEach(member => {
    const highest = getHighestRole(member);
    if (highest) grouped[highest.name].push({ ...member, highestRole: highest });
  });

  // Index runs across every role group so the cascade reads as one motion.
  let cardIndex = 0;

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        <div className="staff-container">
          <h1>ISN NETWORK</h1>
          <h2>Staff Members</h2>
          <p>Meet our dedicated staff members!</p>
          <div className="staff-groups">
            {loading ? (
              <div className="staff-group">
                <div className="staff-cards">
                  {Array.from({ length: 4 }, (_, i) => (
                    <SkeletonStaffCard key={i} />
                  ))}
                </div>
              </div>
            ) : (
              allowedRoles.map(role => (
                grouped[role].length > 0 && (
                  <div className="staff-group" key={role}>
                    <div
                      className="staff-group-header"
                      style={{ color: roleColor(grouped[role][0].highestRole?.color) }}
                    >
                      {role} - {grouped[role].length}
                    </div>
                    <div className="staff-cards">
                      {grouped[role].map(member => (
                        <HoverCard key={member.id} openDelay={120} closeDelay={80}>
                          <HoverCardTrigger asChild>
                            {/* A button so the card is reachable by keyboard
                                too: Radix opens it on focus as well as hover.
                                Touch devices do not hover, but nothing is lost
                                — the card only adds the full role list. */}
                            <button
                              type="button"
                              className="staff-card stagger-item"
                              style={staggerStyle(cardIndex++)}
                            >
                              <img
                                src={member.avatar}
                                alt=""
                                className="staff-avatar"
                              />
                              <div className="staff-info">
                                <span className="staff-name">{capitalizeName(member.name)}</span>
                                <span
                                  className="staff-role"
                                  style={{ color: roleColor(member.highestRole.color) }}
                                >
                                  {member.highestRole.name}
                                </span>
                              </div>
                            </button>
                          </HoverCardTrigger>
                          <HoverCardContent className="staff-hovercard">
                            <div className="staff-hovercard__head">
                              <img src={member.avatar} alt="" className="staff-avatar" />
                              <div>
                                <p className="staff-hovercard__name">
                                  {capitalizeName(member.name)}
                                </p>
                                <p className="staff-hovercard__meta">
                                  {member.roles.filter((r) => r.name !== '@everyone').length} roles
                                </p>
                              </div>
                            </div>
                            <ul className="staff-hovercard__roles">
                              {member.roles
                                .filter((r) => r.name !== '@everyone')
                                .map((r) => (
                                  <li
                                    key={r.id}
                                    style={{ color: roleColor(r.color), borderColor: roleColor(r.color) }}
                                  >
                                    {r.name}
                                  </li>
                                ))}
                            </ul>
                          </HoverCardContent>
                        </HoverCard>
                      ))}
                    </div>
                  </div>
                )
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Staff;
